import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

const Index = () =>
    <div className="fixed top-0 bottom-0 left-0 right-0 -z-50">
        <StaticImage
            alt=""
            src={"bg-container.jpg"}
            className='h-screen bg-cover bg-no-repeat'
            layout={`fullWidth`}
            formats={["auto", "webp", "avif"]}
        />
    </div>




export default Index